import { FormEvent, useState } from 'react';
import { Turnstile } from './Turnstile';

interface ComposerProps {
  siteKey?: string;
  token?: string;
  onToken: (token?: string) => void;
  onSubmit: (text: string) => Promise<void>;
  onCancel: () => void;
  busy: boolean;
}

export function Composer({ siteKey, token, onToken, onSubmit, onCancel, busy }: ComposerProps) {
  const [text, setText] = useState('Whatever we choose, the results should be audited and publicly explained.');

  async function submit(event: FormEvent) {
    event.preventDefault();
    await onSubmit(text);
    setText('');
  }

  return (
    <form className="card composer" onSubmit={submit}>
      <span className="eyebrow">Add a bridge candidate</span>
      <h2>Write the sentence both sides might secretly endorse.</h2>
      <textarea value={text} onChange={(event) => setText(event.target.value)} maxLength={280} />
      <div className="humanRow">
        <Turnstile siteKey={siteKey} onToken={onToken} />
        <p>Same one-line consent applies. The public commons export shows aggregates, not your device key.</p>
      </div>
      <div className="actions">
        <button type="button" className="ghost" onClick={onCancel}>Cancel</button>
        <button className="primary" disabled={busy || !token || text.trim().length < 12}>{busy ? 'Embedding…' : 'Add to map'}</button>
      </div>
    </form>
  );
}
